import replace from "./replace";

const omitTrailingSlash = replace(/\/$/, "");

export default omitTrailingSlash;
